import { JOURNAL_RUNS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/journal_runs_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['journalRunsIndex']);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
